import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var AdminForm = /*#__PURE__*/function (_Entity) {
  _inherits(AdminForm, _Entity);

  var _super = _createSuper(AdminForm);

  function AdminForm() {
    _classCallCheck(this, AdminForm);

    return _super.apply(this, arguments);
  }

  _createClass(AdminForm, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "folderId",
    get: function get() {
      return this.props.folderId;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var collection = [{
        argument: props.id,
        argumentName: 'Admin Form Id'
      }, {
        argument: props.title,
        argumentName: 'Admin Form Title'
      }, {
        argument: props.status,
        argumentName: 'Admin Form Status'
      }, {
        argument: props.folderId,
        argumentName: 'Admin Form Folder Id'
      }, {
        argument: props.createdBy,
        argumentName: 'Admin Form Created By'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new AdminForm(props, new UniqueEntityID(props.id)));
    }
  }]);

  return AdminForm;
}(Entity);